import { DolphinIcon } from './DolphinIcon';

/**
 * author: Colton Wiscombe
 * id 578351FA-0F35-41B0-BC7C-A9B33EBEBC4D
 * name dolphin
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dolphin.svg
 * tags
 * - Animal 
 */
export const PorpoiseIcon = DolphinIcon;
export default PorpoiseIcon